import React, { useState } from "react";

/* ================= ROLE DISPLAY & FILTER ================= */

const ROLE_DISPLAY_MAP = {
    RSM: "REGIONAL_SALES_MANAGER",
    SH: "STATE_HEAD",
    ZH: "ZONAL_HEAD",
    NH: "NATIONAL_HEAD",
};

const ALLOWED_ROLES = [
    "DISTRIBUTOR",
    "MASTER_DISTRIBUTOR",
    "NATIONAL_HEAD",
    "MERCHANT",
    "INDEPENDENT_MERCHANT",
    "REGIONAL_SALES_MANAGER",
    "STATE_HEAD",
    "ZONAL_HEAD",
    "ASM",
];


const getDisplayRole = (role) =>
    ROLE_DISPLAY_MAP[role] || role;

const getFullName = (user) =>
    user.fullName || "-";

const getMobilenumber = (user) => user.mobile || "-";

const getshopName = (user) => user.shopName || "-"


/* ================= BUILD HIERARCHY ================= */

const buildHierarchy = (users = []) => {
    const userMap = {};
    const childrenMap = {};

    // filter users based on UI roles
    const filteredUsers = users.filter((u) =>
        ALLOWED_ROLES.includes(getDisplayRole(u.role))
    );

    filteredUsers.forEach((u) => {
        userMap[u.userId] = u;
        childrenMap[u.userId] = [];
    });

    filteredUsers.forEach((u) => {
        if (
            u.parentId &&
            childrenMap[u.parentId] &&
            u.parentId !== u.userId   // 🔥 VERY IMPORTANT
        ) {
            childrenMap[u.parentId].push(u);
        }
    });

    const rootUsers = filteredUsers.filter(
        (u) =>
            !u.parentId ||
            !userMap[u.parentId] ||
            u.parentId === u.userId
    );

    return { rootUsers, childrenMap };
};

/* ================= MAIN COMPONENT ================= */

const UserTable = ({ users, onChangeParent, onChangeRole ,isLoading}) => {
    const { rootUsers, childrenMap } = buildHierarchy(users);

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center py-10 space-y-3">
                {/* Tailwind Spinner */}
                <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
                <div className="text-sm text-slate-500 font-medium">Fetching users...</div>
            </div>
        );
    }
    if (rootUsers.length === 0) {
        return (
            <div className="text-center text-sm text-slate-500">
                No users to display
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {rootUsers.map((user) => (
                <UserBlock
                    key={user.userId}
                    user={user}
                    childrenMap={childrenMap}
                    onChangeParent={onChangeParent}
                    onChangeRole={onChangeRole}
                    level={0}
                />
            ))}
        </div>
    );
};

export default UserTable;

/* ================= USER BLOCK (RECURSIVE) ================= */

const UserBlock = ({
    user,
    childrenMap,
    onChangeParent,
    onChangeRole,
    level,
}) => {
    const [open, setOpen] = useState(true);
    const children = childrenMap[user.userId] || [];

    return (
        <div
            className="border rounded-md bg-white"
            style={{ marginLeft: level * 12 }}
        >
            <div className="flex items-center justify-between px-3 py-2 bg-slate-100">
                {/* <div className="font-medium text-sm">
                    {getFullName(user)} | {getshopName(user)} ({getMobilenumber(user)})
                    <span className="ml-1 text-slate-600 text-xs">
                        ({getDisplayRole(user.role)})
                    </span>

                    <div className="text-[11px] text-slate-500">
                        {user.userId}
                    </div>
                </div> */}

               

<div className="font-medium text-sm">
    {getFullName(user)} | {getshopName(user)} ({getMobilenumber(user)})
    <span className="ml-1 text-slate-600 text-xs">
        ({getDisplayRole(user.role)})
    </span>

    {/* ✅ UPDATED: User ID & Balances */}
    <div className="flex flex-wrap items-center gap-2 mt-0.5">
        <span className="text-[11px] text-slate-500">
            {user.userId}
        </span>
        {/* <div className="flex gap-1 text-xs"> */}
        <div className="flex flex-wrap gap-2 ">
            <span className="bg-slate-100 text-slate-700 px-1.5 py-0.2 rounded font-medium">
                Main: ₹{user?.mainBalance ?? 0}
            </span>
            <span className="bg-slate-100 text-slate-700 px-1.5 py-0.2 rounded font-medium">
                AePS: ₹{user?.aepsBalance ?? 0}
            </span>
            <span className="bg-slate-100 text-slate-700 px-1.5 py-0.2 rounded font-medium">
                Settle: ₹{user?.settleBalance ?? 0}
            </span>
        </div>
    </div>
</div>

                <div className="flex items-center gap-1.5">
                    <span className="text-[11px] text-slate-500">
                        {children.length} under
                    </span>

                    <button
                        onClick={() => onChangeRole(user)}
                        className="px-1.5 py-0.5 bg-indigo-600 text-white text-[11px] rounded"
                    >
                        Role
                    </button>

                    <button
                        onClick={() => onChangeParent(user)}
                        className="px-1.5 py-0.5 bg-emerald-600 text-white text-[11px] rounded"
                    >
                        Map
                    </button>

                    {children.length > 0 && (
                        <button
                            onClick={() => setOpen(!open)}
                            className="px-1.5 py-0.5 border text-[11px] rounded"
                        >
                            {open ? "Hide" : "Show"}
                        </button>
                    )}
                </div>
            </div>

            {open && children.length > 0 && (
                <div className="pl-3 py-1 space-y-1 mb-10">
                    {children.map((child) => (
                        <UserBlock
                            key={child.userId}
                            user={child}
                            childrenMap={childrenMap}
                            onChangeParent={onChangeParent}
                            onChangeRole={onChangeRole}
                            level={level + 1}
                        />
                    ))}
                </div>
            )}
        </div>

    );
};
